import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';

interface TotalItemProps {
  total: number;
}

function TotalItem({ total }: TotalItemProps) {
  return (
    <>
      <div className="w-full border-t border-system-500 flex py-4">
        <span className="text-text-gray text-lg font-semibold">Total</span>
        <div className="ml-auto">
          <span className="text-purple-300 text-lg font-semibold">
            ${formatCurrency(total)}
          </span>
        </div>
      </div>
      <span className="text-sm text-neutral-400">
        Los puntos se aplican en el checkout
      </span>
    </>
  );
}

export default TotalItem;
